import React from "react";
import "./dashboard-icon.css";

function Dashboardicon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28.124"
        height="25.971"
        viewBox="0 0 28.124 25.971"
        className="dashboard"
      >
        <defs></defs>
        <g transform="translate(-81.223 -98.596)">
          <path
            d="M81.93,113.365,95.285,100.01l13.355,13.355"
            transform="translate(0)"
          />
          <path
            className="dashboard"
            d="M146.786,173.67l9,8.668v5.517a3.6,3.6,0,0,1-3.587,3.587H141.407a3.6,3.6,0,0,1-3.587-3.587v-5.517Z"
            transform="translate(-51.501 -67.876)"
          />
        </g>
      </svg>
    </>
  );
}

export default Dashboardicon;
